export const STEP_NAMES = {
  0: 'account',
  1: 'address',
  2: 'join',
};

const removeLeadingZero = (phoneNumber) => {
  const numStr = typeof phoneNumber === 'string' ? phoneNumber : phoneNumber.toString();

  return numStr.replace(/^0+/, '');
};

export const formatPhoneNumber = (phonePrefix, phoneNumber) => {
  const sanitizedPhoneNumber = removeLeadingZero(phoneNumber);
  if (phonePrefix === 'Others') {
    const trimmedPhoneNumber = sanitizedPhoneNumber.replaceAll('+', '');
    return `+ ${trimmedPhoneNumber}`;
  }
  return `${phonePrefix} ${sanitizedPhoneNumber}`;
};

